export default __webpack_public_path__ + "static/media/landing-page-hero-bg.588a7502.jpg";